import { Box, Button, TextField } from '@mui/material';
import { AddOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import type { FormEvent } from 'react';

import { getClientsPageTokens } from '../getClientsPageTokens';
import { CLIENTS_PAGE_LAYOUT_SIZES } from '../clientsTokens';

export interface AddClientFormProps {
  clientName: string;
  disabled: boolean;
  onClientNameChange: (value: string) => void;
  onSubmit: (event: FormEvent) => void;
}

export function AddClientForm({
  clientName,
  disabled,
  onClientNameChange,
  onSubmit,
}: AddClientFormProps): JSX.Element {
  const theme = useTheme();
  const tokens = getClientsPageTokens(theme);

  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
    >
      <TextField
        value={clientName}
        onChange={(event) => onClientNameChange(event.target.value)}
        placeholder="New client"
        size="small"
        fullWidth
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarFieldRadius}px`,
            bgcolor: tokens.toolbarFieldBg,
            '& fieldset': { border: 'none' },
          },
        }}
      />
      <Button
        type="submit"
        variant="contained"
        disabled={disabled || !clientName.trim()}
        startIcon={<AddOutlined />}
        sx={{
          flexShrink: 0,
          minHeight: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarControlHeight}px`,
          height: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarControlHeight}px`,
          px: 2,
          borderRadius: `${CLIENTS_PAGE_LAYOUT_SIZES.toolbarFieldRadius}px`,
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '16px',
          bgcolor: tokens.primaryButtonBg,
          color: tokens.primaryButtonColor,
          boxShadow: 'none',
          '&:hover': {
            bgcolor: tokens.primaryButtonHoverBg,
            boxShadow: 'none',
          },
        }}
      >
        Add
      </Button>
    </Box>
  );
}
